module.exports = __webpack_public_path__ + "static/media/SelectCheck.c067ec99.svg";